"use client"

import { TSP_CONFIG } from "../config"
import { Crown } from "lucide-react"
import Link from "next/link"

import { newFrontendURL } from "@/lib/new-url"

import { Button } from "@/components/ui/button"

export function UpgradeSidebarCard() {
  return (
    <div className="bg-card rounded-lg border p-3 text-xs">
      <div className="flex items-center gap-2">
        <Crown className="size-4" />
        <span className="font-medium">Free plan</span>
      </div>
      <Link href={newFrontendURL(TSP_CONFIG, "/upgrade-to-pro/", true)}>
        <Button size="sm" className="mt-3 h-7 w-full text-xs">
          Upgrade to pro
        </Button>
      </Link>
    </div>
  )
}
